import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { countriesData as countresDataMain } from './CountriesData';
import { highlightGeoJsonCountryLayer } from '../../state-management/actions/map-actions';
import {
	closeCountrySongsModal,
	closeAddSongToPlaylistModal,
	openCountrySongsModal
} from '../../state-management/actions/modal-actions';
import {
	getCountrySongsRequest,
	setSelectedCountry
} from '../../state-management/actions/songs-actions';
import CardContent from '@material-ui/core/CardContent';
import CardTitleContainer from '../layout/CardTitleContainer';
import FlagIcon from '../misc/FlagIcon';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';
import '../../style/CountryList.css';
import {
	CountriesListContainer,
	CountriesListLi,
	CountriesListMenu,
	CountriesListUl,
	TextFieldSearch,
	SearchValueInput
} from './StyledComponents/StyleCountriesList';
import {
	flexDirection
} from '../../style/Global';
import {
	CloseButton
} from '../../style/Global';
import ViewOptions from './ViewOptions';
import {
	FaPlay,
	FaPause
} from "react-icons/fa";

class CountriesList extends Component {
	constructor(props) {
		super(props);

		const countriesData = _(countresDataMain()).map(country => {
			return {
				name: country['name'],
				alpha2: country["alpha-2"].toLowerCase()
			}

		})
			.filter(country => country.name !== 'Antarctica')
			.value();

		this.state = {
			countriesData,
			filteredCountriesData: countriesData,
			searchValue: '',
			isPlaySignShowing: false,
			countryHighlighted: ''
		};
	}

	componentDidMount() {

		setTimeout(() => {
			const { countryParameter } = this.props;
			if (countryParameter) {
				setTimeout(() => this.selectCountry(countryParameter), 2000);
			}

		});

	}

	clearSearchValue = () => {
		const { countriesData } = this.state;
		this.setState((prevState) => ({
			...prevState,
			searchValue: '',
			filteredCountriesData: countriesData
		}));
	}

	onSearchCountryByName = (event) => {
		const { countriesData } = this.state;
		const { name, value } = event.target;

		console.log('contr ies wit', value);
		const filteredCountriesData = _(countriesData).filter(country => country.name.toLowerCase().startsWith(value.toLowerCase())).value();

		this.setState((prevState) => ({
			...prevState,
			[name]: value,
			filteredCountriesData
		}));

	}

	selectCountry = (countryName) => {
		const {
			closeCountrySongsModal,
			closeAddSongToPlaylistModal,
			getCountrySongsRequest,
			history,
			openCountrySongsModal,
			setSelectedCountry
		} = this.props;

		const selectedCountry = {
			countrySelected: countryName
		}
		getCountrySongsRequest(selectedCountry);
		setSelectedCountry(countryName);
		// openCountrySongsModal();
		// history.push(`/explore/${encodeURIComponent(countryName.toLowerCase())}`);
	}

	highlightCountry = (countryName) => {
		const { highlightGeoJsonCountryLayer } = this.props;
		highlightGeoJsonCountryLayer(countryName);

		this.setState({ isPlaySignShowing: true, countryHighlighted: countryName });
	}

	unhighlightCountry = () => {
		const { highlightGeoJsonCountryLayer } = this.props;
		highlightGeoJsonCountryLayer('');

		this.setState({ isPlaySignShowing: false, countryHighlighted: '' });
	}

	render() {
		const { filteredCountriesData, searchValue, countryHighlighted, isPlaySignShowing } = this.state;
		const {
			selectedCountryName,
			viewOptionSelected
		} = this.props;

		return (
			<CountriesListMenu className="ref-countries-list-menu"
				active={viewOptionSelected === 'ListOnly' ? 1 : 0}
			>
				<CardContent style={{ ...flexDirection.column, flex: '1 1 auto' }} className='ref-flag-container'>
					<CardTitleContainer className='countries-list-title'>
						<Typography variant='h4' gutterBottom
							style={{
								color:'#FF6B6B'
							}}
						>
							Countries List
					</Typography>
						{viewOptionSelected === 'ListOnly' && <ViewOptions />}
					</CardTitleContainer>
					<div style={flexDirection.row}>
						<TextFieldSearch
							className='ref-text-field-search'
							id="standard-search"
							label="Search country..."
							type="search"
							autoComplete="current-password"
							variant="outlined"
							onChange={this.onSearchCountryByName}
							name="searchValue"
						/>

					</div>
					<CountriesListContainer className='ref-countries-list-container'

					>
						<CountriesListUl className='ref-countries-list-ul'>
							{
								filteredCountriesData.map(countryData => (
									<CountriesListLi
										className='ref-countries-list-li'
										key={countryData.name}
										onClick={() => this.selectCountry(countryData.name)}
										onMouseOver={() => this.highlightCountry(countryData.name)}
										onMouseLeave={this.unhighlightCountry}
										style={{
											color:'#9facbd',
											textAlign:'center'
										}}
									>

										<div
											style={{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}

										>
											{isPlaySignShowing && countryHighlighted === countryData.name &&
												selectedCountryName !== countryData.name &&
												<div
													style={{
														position: 'absolute',
														zIndex: 10,
														color:'black'
													}}
												>
													<FaPlay />

												</div>
											}											
											{
												selectedCountryName === countryData.name &&
												<div
													style={{
														position: 'absolute',
														zIndex: 10,														
														color:'black'
													}}
												>
													<FaPause />
												</div>
											}
											<div
												style={{
													opacity: selectedCountryName === countryData.name ||
														countryHighlighted === countryData.name ? 0.5 : 1.0
												}}
											>
												<FlagIcon code={countryData.alpha2} size='4x' />

											</div>

										</div>

										<h6
											style={{
												wordWrap: 'break-word'
											}}
										>
											{countryData.name}
										</h6>
										{/* {selectedCountryName === countryData.name &&
											<p>Selected</p>} */}

									</CountriesListLi>
								))
							}

						</CountriesListUl>
					</CountriesListContainer>
				</CardContent>
			</CountriesListMenu>
		);
	}
}

const mapStateToProps = state => {
	const { modalReducers, parameterReducers, songsReducers } = state;
	// console.log('state',state);
	// console.log('songsReducers', songsReducers);
	const { selectedCountryName } = songsReducers;
	const {
		countryParameter,
		songIdParameter
	} = parameterReducers;
	const {
		viewOptionSelected
	} = modalReducers;
	return {
		countryParameter,
		selectedCountryName,
		songIdParameter,
		viewOptionSelected
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		closeCountrySongsModal: () => dispatch(closeCountrySongsModal()),
		closeAddSongToPlaylistModal: () => dispatch(closeAddSongToPlaylistModal()),
		getCountrySongsRequest: (selectedCountrySongs) => dispatch(getCountrySongsRequest(selectedCountrySongs)),
		highlightGeoJsonCountryLayer: (countryName) => dispatch(highlightGeoJsonCountryLayer(countryName)),
		openCountrySongsModal: () => dispatch(openCountrySongsModal()),
		setSelectedCountry: (selectedCountryName) => dispatch(setSelectedCountry(selectedCountryName))
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CountriesList));